import React from 'react';
import { css } from 'glamor';

import { FormattedMessage } from 'react-intl';

import Cross from 'depop/components/icons/Cross';

export default class AppBanner extends React.Component {
  props: {
    link: String,
    path: String,
    open: Boolean,
    close: () => void,
  };

  render() {
    const { link, open, close } = this.props;

    const deeplinkPath = !!this.props.path;

    return (
      <div {...css({
        display: open && deeplinkPath ? 'flex' : 'none',
        visibility: open && deeplinkPath ? 'visible' : 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        width: '10em',
        marginLeft: '-5em',
        bottom: '20px',
        left: '50%',
        color: 'white',
        backgroundColor: '#D81F2A',
        border: '1px solid #B71922',
        borderRadius: '30px',
        zIndex: '9999',
      })}>
        <a href="javascript:;"
          onClick={close}
          {...css({
            display: 'block',
            width: 12,
            height: 14,
            marginRight: '13px',
          })}>
          <Cross fill="white" />
        </a>
        <a
          {...css({
            display: 'block',
            padding: '10px 0',
            fontSize: 14,
            textAlign: 'center',
            textDecoration: 'none',
            color: 'inherit',
          })}
          href={link}><FormattedMessage
            id="AppBanner.openApp"
            description="Call to action on app banner, MUST BE SMALL"
            defaultMessage="Open in app" /></a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/components/banners/AppBanner.js